//textos dos termos e condições
export const mapTermsConditions = (idModulo) => {
  const currentData = {
    1: {
      titulo:
        'Declaração de ciência e responsabilidade para participação no Seminário Empretec',
      descricoes: [
        {
          id: 1,
          titulo: 'DECLARO ciência de que:',
          descricao: [
            'O seminário do Empretec tem caráter intensivo, com 60 horas de imersão, distribuídas em 6 dias de Seminário. Para que todas as atividades propostas na metodologia sejam realizadas, a carga horária diária poderá ser ampliada, incluindo a realização depossíveis atividades fora do ambiente do Sebrae como: saídas a campoe atividades após a jornada diária do Empretec e atividades para casa.',
            'O Seminário do Empretec poderá ser realizado somente uma vez, ou seja, caso eu abandone o curso não poderei me inscrever novamente e nem poderei me inscrever em uma nova turma.',
            'O SEBRAE não recomenda a participação no seminário, na mesma turma, os sócios, cônjuges e parentes.',
          ],
        },
        {
          id: 2,
          titulo: 'DECLARO:',
          descricao: [
            'Estar em plenas condições de bem-estar físico, mental e emocional, necessários ao aproveitamento da intensidade do Seminário Empretec, que possui várias atividades vivenciais a que serei desafiado a realizar, já que o seminário possui base comportamental com diversos estímulos durante a imersão.',
            'Estar ciente que é de minha inteira responsabilidade pelas informações prestadas sobre meu estado de saúde e bem-estar físico, estando ciente de que a falsidade nas informações acima implicará em possíveis riscos a sua saúde física, mental e emocional.',
            'Me comprometer a cumprir às orientações e atividades que forem repassadas durante a realização do Seminário Empretec.',
            'Por fim, manifesto meu INTERESSE e CONCORDÂNCIA de que as ações vinculadas ao Seminário Empretec contratado por mim sejam realizadas, observada a sua metodologia.',
          ],
        },

        {
          id: 3,
          titulo: 'Termos e políticas de Privacidade:',
          descricao: [
            'Os dados informados para o processo de seleção ao Seminário do Empretec, serão usados para fins do processo de seleção e inscrição no Seminário, caso o candidato passe na entrevista de seleção.',
            'Os dados de contato, e-mail, endereço e telefone poderão ser utilizados para os processos relacionados ao Seminário, incluindo o envio de comunicações relacionadas ao processo de pagamento, inscrição, envio de certificado e ações de relacionamento posteriores ao Empretec como: Seminário pós Empretec, Seminário anual de Empretecos, entre outros.',
            'O Sebrae irá realizar o tratamento dos dados pessoais de forma adequada à lei 13.709.18.',
          ],
        },
      ],
    },
    2: {
      titulo:
        'Declaração de ciência e responsabilidade para participação no Seminário Empretec Startup',
      descricoes: [
        {
          id: 1,
          titulo: 'DECLARO ciência de que:',
          descricao: [
            'O seminário do Empretec Startup tem caráter intensivo, com 50 horas de imersão, distribuídas em 5 dias de Seminário. Para que todas as atividades propostas na metodologia sejam realizadas, a carga horária diária poderá ser ampliada, incluindo a realização de possíveis atividades fora do ambiente do Sebrae como: saídas a campo e atividades após a jornada diária do Empretec e atividades para casa.',
            'O Seminário do Empretec Startup poderá ser realizado somente uma vez, ou seja, caso eu abandone o curso não poderei me inscrever novamente e nem poderei me inscrever em uma nova turma.',
            'O SEBRAE não recomenda a participação no seminário, na mesma turma, os sócios, cônjuges e parentes.',
          ],
        },
        {
          id: 2,
          titulo: 'DECLARO:',
          descricao: [
            'Estar em plenas condições de bem-estar físico, mental e emocional, necessários ao aproveitamento da intensidade do Seminário Empretec, que possui várias atividades vivenciais a que serei desafiado a realizar, já que o seminário possui base comportamental com diversos estímulos durante a imersão.',
            'Estar ciente que é de minha inteira responsabilidade pelas informações prestadas sobre meu estado de saúde e bem-estar físico, estando ciente de que a falsidade nas informações acima implicará em possíveis riscos a sua saúde física, mental e emocional.',
            'Me comprometer a cumprir às orientações e atividades que forem repassadas durante a realização do Seminário Empretec.',
            'Por fim, manifesto meu INTERESSE e CONCORDÂNCIA de que as ações vinculadas ao Seminário Empretec contratado por mim sejam realizadas, observada a sua metodologia.',
          ],
        },
        {
          id: 3,
          titulo: 'Termos e políticas de Privacidade:',
          descricao: [
            'Os dados informados para o processo de seleção ao Seminário do Empretec Startup, serão usados para fins do processo de seleção e inscrição no Seminário, caso o candidato passe na entrevista de seleção.',
            'Os dados de contato, e-mail, endereço e telefone poderão ser utilizados para os processos relacionados ao Seminário, incluindo o envio de comunicações relacionadas ao processo de pagamento, inscrição, envio de certificado e ações de relacionamento posteriores ao Empretec como: Seminário pós Empretec, Seminário anual de Empretecos, entre outros.',
            'O Sebrae irá realizar o tratamento dos dados pessoais de forma adequada à lei 13.709.18.',
          ],
        },
      ],
    },
    3: {
      titulo:
        'Declaração de ciência e responsabilidade para participação no Seminário Empretec Arena',
      descricoes: [
        {
          id: 1,
          titulo: 'DECLARO ciência de que:',
          descricao: [
            'O seminário do Empretec Arena tem caráter intensivo, com 40 horas de imersão, distribuídas em 1 noite e 4 dias de Seminário. Para que todas as atividades propostas na metodologia sejam realizadas, a carga horária diária poderá ser ampliada, incluindo a realização de possíveis atividades fora do ambiente do Sebrae como: saídas a campo e atividades após a jornada diária do Empretec e atividades para casa. O SEBRAE não recomenda a participação no seminário, na mesma turma, os sócios, cônjuges e parentes.',
          ],
        },
        {
          id: 2,
          titulo: 'DECLARO:',
          descricao: [
            'Estar em plenas condições de bem-estar físico, mental e emocional, necessários ao aproveitamento da intensidade do Seminário Empretec Arena, que possui várias atividades vivenciais a que serei desafiado a realizar, já que o seminário possui base comportamental com diversos estímulos durante a imersão. Estar ciente que é de minha inteira responsabilidade pelas informações prestadas sobre meu estado de saúde e bem-estar físico, estando ciente de que a falsidade nas informações acima implicará em possíveis riscos a sua saúde física, mental e emocional. Me comprometer a cumprir às orientações e atividades que forem repassadas durante a realização do Seminário Empretec Arena. Por fim, manifesto meu INTERESSE e CONCORDÂNCIA de que as ações vinculadas ao Seminário Empretec Arena contratado por mim sejam realizadas, observada a sua metodologia.',
          ],
        },

        {
          id: 3,
          titulo: 'Termos e políticas de Privacidade:',
          descricao: [
            'Os dados informados para o processo de seleção ao Seminário do Empretec, serão usados para fins do processo de seleção e inscrição no Seminário, caso o candidato passe na entrevista de seleção. Os dados de contato, e-mail, endereço e telefone poderão ser utilizados para os processos relacionados ao Seminário, incluindo o envio de comunicações relacionadas ao processo de pagamento, inscrição, envio de certificado e ações de relacionamento posteriores ao Empretec como: Seminário pós Empretec, Seminário anual de Empretecos, entre outros. O Sebrae irá realizar o tratamento dos dados pessoais de forma adequada à lei 13.709.18.',
          ],
        },
      ],
    },
  };

  return currentData[idModulo];
};
